<template>
  <div class="questions-list">
    <div v-if="loadingQuestions" class="loading">
      <MoonLoader />
    </div>
    <div v-else class="h-full">
      <div v-if="copyOfScoreFilters.includes('By Impact')">
        <div v-if="sortedQuestions.length > 0">
          <div v-for="(question, index_q) in sortedQuestions" v-bind:key="index_q">
            <Suggestion
              v-if="questionLayout === 'Suggestion' || questionType.name === 'Initiative'"
              :question="question"
            >
            </Suggestion>
            <QuestionEdit
              v-if="questionLayout === 'Edit' && questionType.name !== 'Initiative'"
              :question="question"
              :question-index="index_q"
            ></QuestionEdit>
            <Question
              v-if="questionLayout === 'Answer'"
              :answer="getAnswer(question)"
              :question="question"
              :question-index="index_q"
              :company="company"
            />
          </div>
        </div>
        <div v-else class="loading">
          <MoonLoader />
        </div>
      </div>

      <div v-else>
        <div v-for="(categories, index) in filteredQuestions" v-bind:key="index">
          <div v-if="foundQuestions" v-for="(subcategories, index_sub) in categories[1]" v-bind:key="index_sub">
            <div v-if="subcategories[1].length > 0">
              <div class="questions-list__header u-margin-bottom-small">
                <span class="questions-list__category"> {{ categories[0] }} </span>
                <span v-if="subcategories[0]">
                  | <span class="questions-list__subcategory">{{ subcategories[0] }}</span>
                </span>
              </div>
              <div v-for="(question, index_q) in subcategories[1]" v-bind:key="index_q">
                <Suggestion
                  v-if="questionLayout === 'Suggestion' || questionType.name === 'Initiative'"
                  :question="question"
                  @deleted="removeQuestion($event, index, index_sub, index_q)"
                />
                <QuestionEdit
                  v-if="questionLayout === 'Edit' && questionType.name !== 'Initiative'"
                  :question="question"
                  :question-index="index_q"
                  @deleted="removeQuestion($event, index, index_sub, index_q)"
                />
                <Question
                  v-if="questionLayout === 'Answer'"
                  :answer="getAnswer(question)"
                  :question="question"
                  :question-index="index_q"
                  :company="company"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="questionType">
        <div v-if="!foundQuestions" class="notFound">
          <h3 v-if="questionLayout === 'Suggestion'">No current active initiatives</h3>
          <h3 v-else>Sorry, no questions were found :(</h3>
        </div>
      </div>
      <div v-else class="notFound">
        <h3>Please select a Question Type</h3>
      </div>
    </div>
  </div>
</template>

<script>
import Question from './Question';
import MoonLoader from '../svg/SvgLoaderMoon';
import QuestionEdit from '@/components/Questions/QuestionEdit';
import ProgressBarSecondary from '@/components/Bars/ProgressBarSecondary';
import Suggestion from '@/pages/Suggestions/Suggestion';
import ScoreController from '@/controllers/Score/ScoreController';

export default {
  name: 'QuestionsList',
  components: { Suggestion, ProgressBarSecondary, QuestionEdit, MoonLoader, Question },
  props: {
    questions: {
      type: Object,
    },
    company: {
      type: Object,
    },
    answers: {
      type: Array,
    },
    search: {
      type: String,
      default: '',
    },
    questionLayout: {
      type: String,
      default: 'Answer',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    questionEdit: {
      type: Boolean,
      default: false,
    },
    questionType: {
      type: Object,
    },
  },
  data() {
    return {
      value: null,
      foundQuestions: true,
      maxWeight: null,
    };
  },
  computed: {
    filteredQuestions() {
      this.foundQuestions = false;
      let filteredQuestions = [];

      if (this.filters.length > 0) {
        filteredQuestions = this.searchWithFilters();
      } else {
        filteredQuestions = this.searchWithoutFilters();
      }
      filteredQuestions = filteredQuestions.sort();
      return filteredQuestions;
    },
    sortedQuestions() {
      let sortedQuestions = [];
      let score_filters = this.copyOfScoreFilters;
      if (score_filters.includes('By Impact')) {
        Object.entries(this.questions).forEach((categoryQ) => {
          let category = categoryQ[1];
          if (!Array.isArray(category)) category = Object.keys(category).map((key) => [key, category[key]]);
          categoryQ[1] = category.map((subCategoryQ) => {
            subCategoryQ[1] = subCategoryQ[1].filter((question) => {
              sortedQuestions.push(question);
              return true;
            });
            return subCategoryQ;
          });
        });

        if (sortedQuestions && sortedQuestions.length > 0) {
          sortedQuestions.sort((a, b) => {
            return b.question_weight - a.question_weight;
          });
        }
      }
      return sortedQuestions;
    },
    loadingQuestions() {
      return this.loading;
    },
    copyOfScoreFilters() {
      return this.filters.filter(function (filter) {
        return !filter.name;
      });
    },
  },
  methods: {
    filterByScore(filter_name, score_from, score_till, question) {
      let answer = this.getAnswer(question);
      if (filter_name === 'Not Answered') {
        return Object.keys(answer).length === 0;
      } else {
        let score = answer.achieved_weight / question.question_weight;
        if (score >= score_from && score <= score_till) {
          return true;
        }
      }
    },
    getAnswer(question) {
      if (this.answers) {
        let foundAnswer = Object.entries(this.answers).find(function (answer) {
          return question.id === answer[1].question.id;
        });
        if (foundAnswer) return foundAnswer[1];
      }
      return {};
    },
    searchWithFilters() {
      let filteredQuestions = [];
      let result = [];

      let category_filters = this.filters.filter(function (filter) {
        return filter.name;
      });

      let score_filters = this.filters.filter(function (filter) {
        return !filter.name;
      });
      category_filters.forEach((filter) => {
        Object.entries(this.questions).forEach((category) => {
          if (category[0].toLowerCase() === filter.name.toLowerCase()) {
            category[1] = Object.entries(category[1]).map((subCategory) => {
              subCategory[1] = subCategory[1].filter((question) => {
                return this.checkIfMatchesWithSearchValue(question);
              });
              return subCategory;
            });

            filteredQuestions.push(category);
          } else return [];
        });
      });

      if (filteredQuestions.length === 0) {
        filteredQuestions = Object.keys(this.questions).map((key) => [key, this.questions[key]]);
      }

      if (score_filters.length > 0) {
        filteredQuestions.forEach((categoryQ) => {
          let category = categoryQ[1];
          if (!Array.isArray(category)) category = Object.keys(category).map((key) => [key, category[key]]);
          categoryQ[1] = category.map((subCategoryQ) => {
            subCategoryQ[1] = subCategoryQ[1].filter((question) => {
              if (score_filters.includes('Done')) {
                if (this.filterByScore('Done', 1, 1, question)) {
                  return this.checkIfMatchesWithSearchValue(question);
                } else {
                  return false;
                }
              }

              if (score_filters.includes('In Progress')) {
                if (this.filterByScore('In Progress', 0.5, 0.99, question)) {
                  return this.checkIfMatchesWithSearchValue(question);
                } else {
                  return false;
                }
              }

              if (score_filters.includes('Open')) {
                if (this.filterByScore('Open', 0, 0.49, question)) {
                  return this.checkIfMatchesWithSearchValue(question);
                } else {
                  return false;
                }
              }

              if (score_filters.includes('Not Answered')) {
                if (this.filterByScore('Not Answered', 0, 0, question)) {
                  return this.checkIfMatchesWithSearchValue(question);
                } else {
                  return false;
                }
              }
              return true;
            });
            return subCategoryQ;
          });
          result.push(categoryQ);
        });
      } else {
        result = filteredQuestions;
      }
      return result;
    },

    searchWithoutFilters() {
      if (this.questions) {
        return Object.entries(this.questions).map((category) => {
          category[1] = Object.entries(category[1]).map((subCategory) => {
            subCategory[1] = subCategory[1].filter((question) => {
              if (question.question_text.toLowerCase().includes(this.search.toLowerCase())) {
                this.foundQuestions = true;
                return true;
              }
            });
            return subCategory;
          });
          return category;
        });
      }
    },

    removeQuestion(question, index, index_sub, index_q) {
      this.questions[this.filteredQuestions[index][0]][this.filteredQuestions[index][1][index_sub][0]].splice(
        index_q,
        1
      );
      this.filteredQuestions[index][1][index_sub][1].splice(index_q, 1);
    },

    checkIfMatchesWithSearchValue(question) {
      if (question.question_text) {
        let matchWithSearchValue = question.question_text.toLowerCase().includes(this.search.toLowerCase());
        this.foundQuestions = matchWithSearchValue;
        return matchWithSearchValue;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.notFound {
  display: flex;
  justify-content: center;
  align-items: center;
  /*display: inline-block;*/
  /*position: absolute;*/
  /*top:50%;*/
  /*left: 50%;*/
  /*transform: translate(-50%, -50%);*/
}
</style>
